import type { NetworkData } from '@dynamic-labs-sdk/client';
import { createBaseNetworkProvider } from '@dynamic-labs-sdk/client/core';

import type { SuiNetworkProvider } from '../../SuiNetworkProvider.types';
import { fetchSuiBalance } from '../fetchSuiBalance';

export const createSuiNetworkProvider = (
  networkData: NetworkData
): SuiNetworkProvider => ({
  ...createBaseNetworkProvider('SUI', networkData),
  getBalance: async ({ address }) => ({
    balance: await fetchSuiBalance({
      address,
      networkData,
    }),
  }),
});
